module.exports = __webpack_public_path__ + "img/宣传_180.677d1311.jpg";